import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import ComparisonSection from './components/ComparisonSection';
import TrustSection from './components/TrustSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { faqItems } from '@/mocks/categories';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Superbuy Spreadsheet - Ultimate Guide to Smarter Product Research',
    description: 'Discover the ultimate Superbuy Spreadsheet resource guide. Explore organized product categories, comparison tools, QC guides, and expert shopping strategies.',
    url: siteUrl,
    isPartOf: {
      '@type': 'WebSite',
      name: 'SuperbuySpread',
      url: siteUrl,
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'SuperbuySpread',
    url: siteUrl,
    description: 'Independent educational platform helping users discover and understand Superbuy Spreadsheet resources.',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhatIsSection />
        <ComparisonSection />
        <TrustSection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}